import { Action } from 'redux';
import { HomeAddFavoriteSucceeded, HomeCloseWelcomeChannel, HomeFetchFavoritesSucceeded, HomeFetchPopularSucceeded, HomeFetchRecentsSucceeded, HomeFetchRecommendationsSucceeded, HomeFetchSharedWithMeSucceeded, HomeGetWelcomeChannelInfo, HomeRemoveFavoriteSucceeded, HomeUpdateShowWelcomeChannel } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { ListResult } from '../../ts/fetchers/ListResult';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { GetServerWelcomeChannelInfoResult, ServerWelcomeChannelInfo } from '../../ts/ServerApi/requests/GetServerWelcomeChannelInfoRequest';
import { FavoriteItemType } from '../../ts/ServerApi/types/IFavorite';

export interface HomeSucceededAction extends Action {
  readonly result: ListResult<IContentInfo>;
}

export interface HomeAddFavoriteSucceededInterface extends Action {
  contentId: string;
  contentType: FavoriteItemType;
}

export interface HomeRemoveFavoriteSucceededInterface extends Action {
  contentId: string;
  contentType: FavoriteItemType;
}

export interface HomeServerWelcomeChannelInfoSucceeded extends Action {
  readonly welcomeChannelInfo: ServerWelcomeChannelInfo;
}

export interface HomeUpdateShowWelcomeChannel extends Action {
  readonly showWelcomeChannel: boolean;
}

/*
 * action creators
 */

export function getHomeFetchFavoritesSucceededAction(result: ListResult<IContentInfo>): HomeSucceededAction {
  return {
    type: HomeFetchFavoritesSucceeded,
    result
  };
}

export function getHomeFetchRecentsSucceededAction(result: ListResult<IContentInfo>): HomeSucceededAction {
  return {
    type: HomeFetchRecentsSucceeded,
    result
  };
}

export function getHomeFetchPopularSucceededAction(result: ListResult<IContentInfo>): HomeSucceededAction {
  return {
    type: HomeFetchPopularSucceeded,
    result
  };
}

export function getHomeFetchRecommendationsSucceededAction(result: ListResult<IContentInfo>): HomeSucceededAction {
  return {
    type: HomeFetchRecommendationsSucceeded,
    result
  };
}

export function getHomeFetchSharedWithMeSucceededAction(result: ListResult<IContentInfo>): HomeSucceededAction {
  return {
    type: HomeFetchSharedWithMeSucceeded,
    result
  };
}

export function getHomeAddFavoriteSucceededAction(contentId: string, contentType: FavoriteItemType): HomeAddFavoriteSucceededInterface {
  return {
    type: HomeAddFavoriteSucceeded,
    contentId,
    contentType
  };
}

export function getHomeRemoveFavoriteSucceededAction(contentId: string, contentType: FavoriteItemType): HomeRemoveFavoriteSucceededInterface {
  return {
    type: HomeRemoveFavoriteSucceeded,
    contentId,
    contentType
  };
}

export function getServerWelcomeChannelInfoSucceededAction(result: GetServerWelcomeChannelInfoResult): HomeServerWelcomeChannelInfoSucceeded {
  return {
    type: HomeGetWelcomeChannelInfo,
    welcomeChannelInfo: result,
  };
}

export const ishomeFetchFavoritesSucceededAction = isActionFactory<HomeSucceededAction>(HomeFetchFavoritesSucceeded);
export const ishomeFetchRecentsSucceededAction = isActionFactory<HomeSucceededAction>(HomeFetchRecentsSucceeded);
export const ishomeFetchPopularSucceededAction = isActionFactory<HomeSucceededAction>(HomeFetchPopularSucceeded);
export const ishomeFetchRecommendationsSucceededAction = isActionFactory<HomeSucceededAction>(HomeFetchRecommendationsSucceeded);
export const ishomeFetchSharedWithMeSucceededAction = isActionFactory<HomeSucceededAction>(HomeFetchSharedWithMeSucceeded);
export const isHomeAddFavoriteSucceededAction = isActionFactory<HomeAddFavoriteSucceededInterface>(HomeAddFavoriteSucceeded);
export const isHomeRemoveFavoriteSucceededAction = isActionFactory<HomeRemoveFavoriteSucceededInterface>(HomeRemoveFavoriteSucceeded);
export const isCloseWelcomeChannelAction = isActionFactory<Action>(HomeCloseWelcomeChannel);
export const isGetServerWelcomeChannelInfoSucceeded = isActionFactory<HomeServerWelcomeChannelInfoSucceeded>(HomeGetWelcomeChannelInfo);
export const isUpdateShowWelcomeChannelAction = isActionFactory<HomeUpdateShowWelcomeChannel>(HomeUpdateShowWelcomeChannel);

export function homeCloseWelcomeChannelAction() {
  return {
    type: HomeCloseWelcomeChannel,
  };
}

export function updateShowWelcomeChannelAction(showWelcomeChannel: boolean) {
  return {
    type: HomeUpdateShowWelcomeChannel,
    showWelcomeChannel
  };
}
